import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isCompletedPatient } from '../../helpers';
import ConfirmationDialog from '../ConfirmationDialog';

const CompletedCaseWarning = ({ patient, proceed, cancel }) => {
  const [showDialog, setShowDialog] = useState(isCompletedPatient(patient));

  useEffect(() => {
    if (!isCompletedPatient(patient)) {
      proceed();
    }
  }, [proceed, patient]);

  const handleClosingCompletionWarningDialog = confirm => {
    if (confirm) {
      proceed();
      setShowDialog(null);
    } else {
      if (cancel) {
        cancel();
      }
      setShowDialog(false);
    }
  };

  return (
    <ConfirmationDialog
      open={showDialog === true}
      handleClose={handleClosingCompletionWarningDialog}
      title=""
      bodyText="This case has already been approved. If you open and modify this case, any changes made will not be implemented."
    />
  );
};

CompletedCaseWarning.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  patient: PropTypes.object.isRequired,
  proceed: PropTypes.func.isRequired,
  cancel: PropTypes.func
};

CompletedCaseWarning.defaultProps = {
  cancel: null
};

export default CompletedCaseWarning;
